/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
jQuery(document).ready(function ($) {
	// Add click event to accordion headers
	console.log("custom blocks scripts");

	//TRANSFER STYLE
	$(".wp-block-create-block-gildner-accordion").each(function () {
		var get_item_style = $(this).attr("data-item-style");
		var get_header_style = $(this).attr("data-header-style");
		$(this).removeAttr("data-item-style");
		$(this).removeAttr("data-header-style");
		$(this).find(".gildner-accordion-item").attr("style", get_item_style);
		$(this).find(".gildner-accordion-header").attr("style", get_header_style);

		//STATE INDICATOR
		if ($(this).hasClass("arrow-vertical")) {
			var get_arrow_vertical_style = $(this).attr(
				"data-state-indicator-vertical-style",
			);
			$(this)
				.find(".gildner-toggle-indicator")
				.attr("style", get_arrow_vertical_style);
		} else if ($(this).hasClass("arrow-horizontal")) {
			var get_arrow_horizontal_style = $(this).attr(
				"data-state-indicator-horizontal-style",
			);
			$(this)
				.find(".gildner-toggle-indicator")
				.attr("style", get_arrow_horizontal_style);
		} else if ($(this).hasClass("plus-icon")) {
			var get_plus_icon_style = $(this).attr("data-state-indicator-plus-style");
			$(this)
				.find(".gildner-toggle-indicator .horizontal-line")
				.attr("style", get_plus_icon_style);
			$(this)
				.find(".gildner-toggle-indicator .vertical-line")
				.attr("style", get_plus_icon_style);
		}
		$(this).removeAttr("data-state-indicator-vertical-style");
		$(this).removeAttr("data-state-indicator-horizontal-style");
		$(this).removeAttr("data-state-indicator-plus-style");

		var get_title_color = $(this).attr("data-title-color");
		$(this).find(".gildner-accordion-title").attr("style", get_title_color);
		$(this).removeAttr("data-title-color");

		//CONTENT STYLE
		var get_content_style = $(this).attr("data-content-style");
		$(this).find(".gildner-accordion-body").attr("style", get_content_style);
		$(this).removeAttr("data-content-color");

	});

	//COLLAPSE ON  LOAD
	$(".collapse-false").each(function () {
		$(this).find(".gildner-accordion-body").slideDown();
	});

	$(".gildner-accordion-header").on("click", function () {
		const $accordionItem = $(this).closest(".gildner-accordion-item");
		const $stateIndicator = $(this).find(".gildner-toggle-indicator");

		// Toggle active class for the clicked accordion item
		$accordionItem.toggleClass("active");

		// Optionally close other accordion items if you want only one open at a time
		if (
			$(this).parent().parent().parent().hasClass("one-panel-a-time") == true
		) {
			$accordionItem
				.siblings(".gildner-accordion-item")
				.removeClass("active")
				.find(".gildner-accordion-body")
				.slideUp();
		}

		if ($stateIndicator.hasClass("open")) {
			$stateIndicator.removeClass("open");
		} else {
			$(this).parent().parent().find(".open").removeClass("open");
			$stateIndicator.addClass("open");
		}

		// Toggle the body of the clicked accordion item
		$accordionItem.find(".gildner-accordion-body").slideToggle();
	});
});
/* eslint-enable no-console */
